<template>
  <div class="totp-qrcode" v-if="shouldShowQrcode">
    <a-form-model-item :label="label" prop="googleVerify">
      <!-- 二维码显示 -->
      <vue-qrcode
        :key="googleVerify"
        :value="totpUri"
        :options="qrcodeOptions"
      />
      <!-- 提示文字 -->
      <p class="qrcode-tip">
        <a-icon type="mobile" />
        请使用 Google Authenticator 扫描二维码
      </p>
      <!-- 显示密钥 -->
      <!-- <div class="secret-display" v-if="showSecret">
        <a-typography-text copyable>{{ googleVerify }}</a-typography-text>
      </div> -->
    </a-form-model-item>
  </div>
</template>

<script>
export default {
  name: 'TotpQrcode',
  props: {
    // 账户名称（联系人姓名或用户名）
    accountName: {
      type: String,
      required: true
    },
    // Google验证密钥
    googleVerify: {
      type: String,
      required: true
    },
    // 发行商名称
    issuer: {
      type: String,
      default: process.env.APP_TITLE // 环境变量 APP_TITLE
    },
    // 表单标签
    label: {
      type: String,
      default: '谷歌验证码'
    },
    // 二维码大小
    size: {
      type: Number,
      default: 200
    },
    // 是否显示密钥
    showSecret: {
      type: Boolean,
      default: false
    },
    // 纠错级别
    errorCorrectionLevel: {
      type: String,
      default: 'H'
    }
  },
  watch: {
    googleVerify (newVal, oldVal) {
      console.log('TotpQrcode组件: googleVerify发生变化', { from: oldVal, to: newVal })
    }
  },
  computed: {
    // 是否应该显示二维码
    shouldShowQrcode () {
      return this.accountName && this.googleVerify
    },
    // 二维码配置
    qrcodeOptions () {
      return {
        width: this.size,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#ffffff'
        },
        errorCorrectionLevel: this.errorCorrectionLevel
      }
    },
    // 生成TOTP URI
    totpUri () {
      if (!this.shouldShowQrcode) {
        return ''
      }

      try {
        const encodedIssuer = encodeURIComponent(this.issuer)
        const encodedAccountName = encodeURIComponent(this.accountName)
        const encodedSecret = encodeURIComponent(this.googleVerify)

        const uri = `otpauth://totp/${encodedIssuer}:${encodedAccountName}?secret=${encodedSecret}&issuer=${encodedIssuer}&algorithm=SHA1&digits=6&period=30`

        console.log('生成的TOTP URI:', uri)
        console.log('当前googleVerify:', this.googleVerify)
        return uri
      } catch (error) {
        console.error('生成TOTP URI失败:', error)
        return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.totp-qrcode {
  .qrcode-tip {
    margin-top: 8px;
    color: #666;
    font-size: 12px;
    text-align: left;

    .anticon {
      margin-right: 4px;
      color: #1890ff;
    }
  }

  .secret-display {
    margin-top: 8px;
    padding: 8px;
    background: #f5f5f5;
    border-radius: 4px;
    text-align: center;
    font-family: monospace;
  }
}
</style>
